export default "__VITE_ASSET__FqzdLn4h__"